import {
    createBotGeneralInfoActions,
    createBotVersionCrudActions,
    createCustomModuleHandlesActions,
    createMappieBotActions,
    createReactflowEdgesActions,
    createReactflowNodesActions,
    createTaskValuesActions,
    createTestCallActions,
    createUndoRedoActions,
} from './actions';
import { initialState } from './initial-state';
import { ImmerStateCreator } from './types';

import { EditableBotVersionSlice } from '@/domain/bot';

/**
 * Main editable bot version slice that composes all action creators.
 * This is the single entry point for the Zustand slice.
 */
export const editableBotVersionSlice: ImmerStateCreator<
    EditableBotVersionSlice
> = (set, get) => ({
    // Initial state
    ...initialState,

    // Bot version CRUD actions
    ...createBotVersionCrudActions(set, get),

    // Bot general info actions
    ...createBotGeneralInfoActions(set, get),

    // Mappie bot actions
    ...createMappieBotActions(set, get),

    // Custom module handles actions
    ...createCustomModuleHandlesActions(set, get),

    // ReactFlow nodes actions
    ...createReactflowNodesActions(set, get),

    // ReactFlow edges actions
    ...createReactflowEdgesActions(set, get),

    // Undo/Redo actions
    ...createUndoRedoActions(set, get),

    // Test call actions
    ...createTestCallActions(set, get),

    // Task values actions
    ...createTaskValuesActions(set, get),
});
